import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import Background from './Components/Background/Background';
import Footer from './Components/Footer/Footer';
import Navbar from './Components/Navbar/Navbar';
import Home from './Pages/Home/Home';
import Courses from './Pages/Courses/Courses'
import ListCourses from './Pages/ListCourses/ListCourses';
import ScrollToTop from './Components/ScrollTop/ScrollTop';
import Quiz from './Pages/Quiz/Quiz';
import Certificate from './Pages/Certificate/Certificate';
import Partners from './Pages/Partners/Partners';
import Test from './Pages/Test';
import CourseDetail from './Pages/Detail';
import AboutUs from './Pages/Partners/Partners';
import PartnersInfo from './Components/PartnersInfo/PartnersInfo';
import Payment from './Components/Payment';
import PaymentCredentials from './Components/PaymentCredentials';
import LayoutA from './Components/StudentDashboard';
import StudendDashboard from './Pages/StudenDashboard';
import StudendDashboardInfo from './Pages/StudenDashboard/Info';
import StudendDashboardCourses from './Pages/StudenDashboard/Courses';
import StudendDashboardCertificate from './Pages/StudenDashboard/Certificates';
import StudendDashboardPayment from './Pages/StudenDashboard/PaymentHistory';
import EnrollMentDetail from './Pages/StudenDashboard/Courses/EnrollmentDetail';
import { ToastContainer } from 'react-toastify';
import StudentDashboardCourseDetail from "./Pages/StudenDashboard/Courses/Lesson";
import StudentDashboardQuiz from "./Pages/StudenDashboard/Quiz";
import { useEffect, useState } from 'react';
import OpenPdf from './Components/OpenPdf/OpenPdf';
import News from './Components/News/News';
import PrivateRoute from './Components/PraviteRoute';

function App() {
    const [token, setToken] = useState(localStorage.getItem("token") || "");
    const navigate = useNavigate();
    const location = useLocation();

    // ✅ check token
    useEffect(() => {
        const checkToken = () => {
            const storedToken = localStorage.getItem("token");
            if (!storedToken || storedToken === "undefined" || storedToken === "null") {
                localStorage.removeItem("token");
                setToken("");
                navigate("/");
            }
        };
        window.addEventListener("storage", checkToken);
        return () => {
            window.removeEventListener("storage", checkToken);
        };
    }, [navigate]);

    // ✅ URL dan kurs ID ni olish
    const queryParams = new URLSearchParams(location.search);
    const courseIdFromUrl = 145;
    useEffect(() => {
        localStorage.setItem("courseId", courseIdFromUrl);
    }, []);

    return (
        <div className="App">
            <Background />
            {location.pathname !== "/" && (<Navbar />)}
            <ScrollToTop />

            <Routes>
                {/* ✅ Home endi courseId ni prop sifatida oladi */}
                <Route path='/' element={<Home courseId={courseIdFromUrl} />} />
                <Route path='/courses' element={<ListCourses courseId={courseIdFromUrl}  />} />
                <Route path='/partners' element={<PartnersInfo />} />
                <Route path='/about' element={<AboutUs />} />
                <Route path='/news/:id' element={<News />} />

                {/* Student Dashboard */}
                <Route element={<PrivateRoute />}>
                    <Route path='/payment/credentials' element={<PaymentCredentials />} />
                    <Route path='/courses/:courseId' element={<Courses />} />
                    <Route path='/payment' element={<Payment />} />
                    <Route path='/certificate' element={<Certificate />} />
                    <Route path='/quiz' element={<Quiz />} />
                    <Route path="/quiz/test" element={<Test />} />
                    <Route path="/student/info" element={<StudendDashboardInfo />} />
                    <Route path="/student/courses" element={<StudendDashboardCourses />} />
                    <Route path="/student/courses/:enrollmentId" element={<EnrollMentDetail />} />
                    <Route path="/student/certificate" element={<StudendDashboardCertificate />} />
                    <Route path="/student/payment-history" element={<StudendDashboardPayment />} />
                    <Route path="/student/courses/:enrollmentId/:chapterId/:order" element={<StudentDashboardCourseDetail />} />
                    <Route path="/student/courses/quiz/:enrollmentId/:chapterId" element={<StudentDashboardQuiz />} />
                    <Route path="/student/courses/quiz/:enrollmentId/:chapterId/view-pdf" element={<OpenPdf />} />
                </Route>
            </Routes>

            <Footer />
            <ToastContainer />
        </div>
    );
}

export default App;
